/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAUofl%7Bmin-height%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlgs9g%7Bmax-width%3A420px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmFQfX%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPgVvo%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkoFQfX%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3zvHkHwPeg%7Boverflow-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1T2N03wPeg%7Bword-wrap%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8gVvo%7Bgap%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kk5Tku7m9%7Bfont-weight%3Avar(--ds-font-weight-regular%2C400)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJxFwi%7Bgrid-area%3Ainteractive%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GwItXDIqT%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._49OCfRPgdg%7Binset%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8FQfX%7Bgap%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIw0fc%7Bmin-width%3A1ch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3uh4XpyL8i%3Afocus-within%7Boverflow-x%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2yI6tSyL8i%3Afocus-within%7Boverflow-y%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHjOvk%7Bborder-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2dBcB%7Bgrid-template-columns%3Aminmax(0%2Cauto)%201fr%20minmax(0%2Cauto)%20minmax(0%2Cauto)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ca6V7UfmU%7Bgrid-template-rows%3A1fr%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3NN0tOjIhD%7Bgrid-template-areas%3A%22elem-before%20interactive%20elem-after%20actions%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIL04q%7Bmin-width%3A72px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VZ49V%7Bheight%3A2rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._20VacPYbGa%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0XA9qCYbGa%7B--actions-on-hover-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4Gpka1jOvk%7B--notch-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0B0jWhQ4SZ%7B--elem-after-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4hDavfo126%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3ZMGdpQ4SZ%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39tYIhQ4SZ%3Afocus-within%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2orrW2Q4SZ%3Ahover%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAs7ue%7Bmin-height%3A3.75rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm8HPE%7Bpadding-block-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko8HPE%7Bpadding-block-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYA7hsp%7Bmin-height%3A3.25rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmgVvo%7Bpadding-block-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkogVvo%7Bpadding-block-end%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0B0jWhYbGa%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0XA9qCQ4SZ%7B--actions-on-hover-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gMmAmYbGa%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3R5mzfYbGa%3Afocus-within%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4g9hZtYbGa%3Ahover%7B--elem-after-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4Gpka1kLmD%7B--notch-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4hDavfsumd%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0clgaMjTy9%3Ahover%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHceTh%7Bborder-color%3Avar(--ds-border-discovery%2C%23af59e1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzot27%7Bcolor%3Avar(--ds-text-disabled%2C%23080f214a)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6ZqHV%3Ahover%7Bbackground-color%3Aunset%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VDuDI%7Bheight%3A3rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2j3gqAg8pm%7Bgrid-column%3A1%2F-1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3B2K2Q7dHp%7Bgrid-row%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2qccN%7Bgrid-template-columns%3Asubgrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ca6V7qccN%7Bgrid-template-rows%3Asubgrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm1Y8M%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko1Y8M%7Bpadding-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrujOvk%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA57p2s%7Btext-align%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2FPiMbJNoT%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmPgdg%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkoPgdg%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2FPiMbXsxn%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2FPiMbjOvk%3Aactive%3Anot(%3Adisabled)%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gz715P%7Binset-block-start%3A50%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV024Jdh%7Bwidth%3A2px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcakruI%7Btransform%3AtranslateY(-50%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruzNEo%7Bbackground-color%3Avar(--notch-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJZyOa%7Bgrid-area%3Aelem-before%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02oWWg%7Bwidth%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04iPvdi%7Bbox-sizing%3Acontent-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr07p2s%7Balign-self%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02Uofl%7Bwidth%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E5zaO%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xTnZx8HPE%7Bmargin-inline-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2XwD3GYbGa%3Anot(%3Ahas(button%2Ca))%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJoUfk%7Bgrid-area%3Aelem-after%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbS8hL%7Bdisplay%3Avar(--actions-on-hover-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbx0Ks%7Bdisplay%3Avar(--elem-after-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr0DIqT%7Balign-self%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJnO1v%7Bgrid-area%3Aactions%7D");
import React, { forwardRef, useCallback, useRef } from 'react';
import { cx } from '@compiled/react';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { Anchor, Pressable, Text, type TextColor } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import TooltipPrimitive, { type TooltipPrimitiveProps } from '@atlaskit/tooltip/TooltipPrimitive';
import type { TooltipProps } from '@atlaskit/tooltip/types';
import { COLLAPSE_ELEM_BEFORE, expandableMenuItemIndentation } from '../../constants';
import { forwardRefWithGeneric } from '../../utils/forward-ref-with-generic';
import mergeRefs from '../../utils/merge-refs';
import type { MenuItemCommonProps, MenuItemLinkOrButtonCommonProps, MenuItemOnClick, MenuItemSlots } from './types';
const tooltipStyles = {
  root: "_0bjKvDKxmn _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4kiQYAUofl _1EqgXlgs9g _24h04i2Njc _46hvQmFQfX _03SyCPgVvo _0xmtkoFQfX _0LQT5EgVvo _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _1T2N03wPeg"
};
const MenuItemTooltip = forwardRef<HTMLDivElement, TooltipPrimitiveProps>(function MenuItemTooltip({
  children,
  className,
  ...rest
}, ref) {
  return <TooltipPrimitive {...rest}
  // Manually passing on `className` so it gets merged correctly in the build output.
  // The passed classname is mostly used for integration testing (`.Tooltip`)
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
  className={ax([tooltipStyles.root, className])}
  // "css" does not "exist" - it gets transformed into "className" by compiled
  ref={ref}>
			{children}
		</TooltipPrimitive>;
});
function isTextClamped(element: HTMLElement): boolean {
  // Checking for vertical height rather than horizontal height.
  // When text is "clamped", it's technically being clamped vertically! 🤯
  return element.scrollHeight > element.clientHeight;
}
const elemAfterDisplayVar = '--elem-after-display';
const actionsOnHoverDisplayVar = '--actions-on-hover-display';
const notchColorVar = '--notch-color';

/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */
const topLevelSiblingStyles = {
  root: "_1mT5xdRAKS"
};

/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */
const onTopOfButtonOrAnchorStyles = {
  root: "_2XwD3GYbGa"
};

/**
 * This is being _internally_ exported so it can be used in other menu item wrapper components, like
 * ExpandableMenuItemTrigger.
 *
 * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
 * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
 * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
 * outside the menu item, e.g. if rendered in a portal.
 *
 * An alternative solution might involve wrapping it with a popup context and listening to the popup
 * events through it (and applying the hover style when the popup is open). Exploring this has been
 * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
 */
export const nestedOpenPopupCSSSelector = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const containerStyles = {
  root: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _24h04i2Njc _3iDTPbgBM8 _2iEGP2dBcB _0ca6V7UfmU _3NN0tOjIhD _4ouGXIL04q _0jFU0VZ49V _0hPCNLDIqT _20VacPYbGa _1UtDYzZpcK _0XA9qCYbGa _4Gpka1jOvk _0B0jWhQ4SZ _4hDavfo126 _3ZMGdpQ4SZ _1eOmH6o126 _39tYIhQ4SZ _2orrW2Q4SZ",
  large: "_24h04i2Njc _4kiQYAs7ue _46hvQm8HPE _0xmtko8HPE _03SyCP5zaO",
  small: "_24h04i2Njc _4kiQYA7hsp _46hvQmgVvo _0xmtkogVvo _03SyCPgVvo",
  removeElemAfter: "_0B0jWhYbGa",
  showHoverActions: "_0XA9qCQ4SZ",
  removeElemAfterOnHoverOrOpenNestedPopup: "_3gMmAmYbGa _3R5mzfYbGa _4g9hZtYbGa",
  selected: "_0KLXruY9q9 _1UtDYzjTy9 _4Gpka1kLmD _4hDavfsumd _0clgaMjTy9 _1eOmH6sumd",
  discovery: "_3vBAKHceTh",
  suppressNotch: "_4Gpka1jOvk _0LQT5EgVvo",
  disabled: "_1UtDYzot27 _1eOmH6ZqHV",
  hasDescription: "_0jFU0VDuDI"
};
const buttonOrAnchorStyles = {
  root: "_0bjKvDKxmn _2j3gqAg8pm _3B2K2Q7dHp _3iDTPbgBM8 _2iEGP2qccN _0ca6V7qccN _03SyCP1Y8M _0LQT5E1Y8M _46hvQm1Y8M _0xmtko1Y8M _0KLXrujOvk _1UtDYzZpcK _0hPCNLDIqT _2fwxA57p2s _2FPiMbJNoT",
  large: "_46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg",
  small: "_46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg",
  selected: "_1UtDYzjTy9 _2FPiMbXsxn",
  noActiveBackground: "_2FPiMbjOvk"
};
const extendButtonOrAnchorStyles = {
  root: "_49OCfRPgdg _1mT5xdWVPG"
};
const notchStyles = {
  root: "_1mT5xdWVPG _2I62gz715P _3iC0zdPgdg _39xV024Jdh _0jFU0VxpxF _1VJPcakruI _0KLXruzNEo"
};
const actionStyles = {
  root: "_2mHwu81Y8M _1xC2CJnO1v _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const actionsOnHoverStyles = {
  root: "_1xC2CJoUfk _2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _3iDTPbS8hL _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const textStyles = {
  root: "_2mHwu8FQfX _4bt5LAnQyn _2WAcuGnQyn _03SyCP1Y8M _0LQT5E1Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIw0fc _3uh4XpyL8i _2yI6tSyL8i",
  noElemBeforeIndent: "_0LQT5EgVvo"
};
const elemBeforeStyles = {
  root: "_1xC2CJZyOa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _0LQT5E1Y8M _24h04iPvdi _3uh4XpyL8i _2yI6tSyL8i",
  start: "_4xdlr07p2s",
  large: "_39xV02Uofl _0jFU0VUofl _0LQT5E5zaO _2xTnZx8HPE"
};
const elemAfterStyles = {
  root: "_1xC2CJoUfk _4bt5LAnQyn _2WAcuGnQyn _3iDTPbx0Ks _3YEZNOdnbC _0jFU0VoWWg _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i",
  large: "_4xdlr07p2s",
  small: "_4xdlr0DIqT"
};

/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */
const interactiveContentStyles = {
  root: "_1xC2CJxFwi _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXDIqT _4ouGXIdnbC"
};
const descriptionStyles = {
  rich: "_4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7"
};
const titleStyles = {
  row: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1EqgXlN91d",
  text: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
  suffix: "_2sNsIg7NXe _3YEZNOdnbC _1ANEUSLRg7 _1UtDYzKGUX _1kk5Tku7m9"
};
function getTextColor(isDisabled?: boolean): TextColor {
  if (isDisabled) {
    return 'color.text.disabled';
  }
  return 'color.text';
}

/**
 * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
 *
 * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
 * expanded content for ExpandableMenuItem.
 */
type MenuItemBaseProps<T extends HTMLAnchorElement | HTMLButtonElement> = MenuItemLinkOrButtonCommonProps & {
  /**
   * ID attribute, passed to the interactive element (anchor/button). This is not publicly exposed, and is currently only
   * used internally by `ExpandableMenuItemTrigger` for the `aria-labelledby` attribute.
   */
  id?: string;
  href?: string | Record<string, unknown>;
  target?: HTMLAnchorElement['target'];
  isDisabled?: boolean;
  isSelected?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaControls?: string;
  // eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention, @repo/internal/react/consistent-props-definitions
  ariaExpanded?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaHasPopup?: boolean | 'dialog';
  onClick?: MenuItemOnClick<T>;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'small': 3.4 (54px) height with custom padding
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
  /** Display actionsOnHover even when the menu item is not hovered or expanded. */
  showActionsOnHover?: boolean;
  /** Aligns the leading slot to the top of a multi-line menu item. */
  elemBeforeAlign?: 'center' | 'start';
};

/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */
const MenuItemBaseNoRef = <T extends HTMLAnchorElement | HTMLButtonElement,>({
  id,
  testId,
  actions,
  actionsOnHover,
  showActionsOnHover,
  children,
  titleSuffix,
  description,
  elemAfter,
  elemBefore,
  href,
  target,
  isDisabled,
  isSelected,
  onClick,
  ariaControls,
  ariaExpanded,
  ariaHasPopup,
  interactionName,
  isContentTooltipDisabled,
  visualContentRef,
  level = 0,
  size = 'default',
  noActiveBackground,
  elemBeforeAlign = 'center',
  appearance = 'default'
}: MenuItemBaseProps<T>, forwardedRef: React.ForwardedRef<T>) => {
  const isLink = typeof href !== 'undefined';
  const labelRef = useRef<T | null>(null);
  const descriptionRef = useRef<HTMLElement | null>(null);
  const setDescriptionRef = useCallback((node: HTMLElement | null) => {
    descriptionRef.current = node;
  }, []);
  const tooltipOnClick = useRef<React.MouseEventHandler<HTMLElement> | null>(null);
  const isRichDescription = typeof description !== 'string';
  const handleClick = useCallback((event: React.MouseEvent<T>, analyticsEvent: UIAnalyticsEvent) => {
    onClick?.(event, analyticsEvent);
    tooltipOnClick.current?.(event);
  }, [onClick]);

  /**
   * Show the tooltip if _either_ label or description is truncated
   */
  const canTooltipAppear = useCallback((): boolean => {
    if (isContentTooltipDisabled) {
      return false;
    }

    // Show tooltip if _either_ label or description are clamped

    const label = labelRef.current;
    const description = descriptionRef.current;
    if (label && isTextClamped(label)) {
      return true;
    }
    return Boolean(description && isTextClamped(description));
  }, [isContentTooltipDisabled]);

  // By default provide the spacing for `elemBefore` to have good
  // vertical alignment of labels and to give clear indentation between levels
  // in the side navigation (even when items don't use elemBefore).
  const showElemBefore = elemBefore !== COLLAPSE_ELEM_BEFORE;
  const titleContent = titleSuffix ? <span className={ax([titleStyles.row])}>
			<span className={ax([titleStyles.text])}>{children}</span>
			<span className={ax([titleStyles.suffix])}>{titleSuffix}</span>
		</span> : children;
  const interactiveElemContent = <div className={ax([interactiveContentStyles.root])}>
			{/**
    * We are creating a hidden element to increase the interactive area of our menu items.
    * This enables users to only need to move their pointers vertically to be able to access
    * nested menu items.
    *
    * 📺 More context: https://www.youtube.com/watch?v=zVFJAwrCQCM
    *
    * Notes:
    *
    * - We cannot use `::before` on the interactive element itself as you
    *   cannot drag a `button` element from `::before` in Firefox
    *   https://bugzilla.mozilla.org/show_bug.cgi?id=1967645
    * - The hidden element uses `position:absolute` so it won't impact layout
    *
    */}
			<div
    // This extends the clickable area of nested menu items to the width
    // of the root level menu items, while being visually indented.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    style={{
      insetInlineStart: `calc(-1 * ${level} * ${expandableMenuItemIndentation})`
    }} aria-hidden="true" className={ax([extendButtonOrAnchorStyles.root])} />
			<div className={ax([textStyles.root, !showElemBefore && textStyles.noElemBeforeIndent])}>
				<Text weight="medium" maxLines={1} color={getTextColor(isDisabled)} ref={labelRef}>
					{titleContent}
				</Text>
				{description && isRichDescription ? <div ref={setDescriptionRef} className={ax([descriptionStyles.rich])}>
						{description}
					</div> : null}
				{description && !isRichDescription ? <Text color={isDisabled ? 'color.text.disabled' : 'color.text.subtle'} size="small" maxLines={1} ref={setDescriptionRef}>
						{description}
					</Text> : null}
			</div>
		</div>;

  /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */
  const showHoverActionsWhenNotHovered = Boolean((ariaExpanded || showActionsOnHover) && actionsOnHover);
  const isLarge = size === 'large';
  const isSmall = size === 'small';
  return <div ref={visualContentRef} data-testid={testId ? `${testId}-container` : undefined} data-selected={isSelected} className={ax([containerStyles.root, isLarge && containerStyles.large, isSmall && containerStyles.small, isSelected && containerStyles.selected, appearance === 'discovery' && containerStyles.discovery, containerStyles.suppressNotch, description && !isLarge && containerStyles.hasDescription, showHoverActionsWhenNotHovered && containerStyles.showHoverActions, showHoverActionsWhenNotHovered && elemAfter && containerStyles.removeElemAfter, actionsOnHover && elemAfter && containerStyles.removeElemAfterOnHoverOrOpenNestedPopup, isDisabled && containerStyles.disabled])}>
			<Tooltip content={() => <React.Fragment>
						<div>{titleContent}</div>
						{description ? <div>{description}</div> : null}
					</React.Fragment>} position="right"
    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
    component={(MenuItemTooltip as TooltipProps['component'])} ignoreTooltipPointerEvents hideTooltipOnMouseDown
    // We don't need a duplicate hidden element containing tooltip content
    // as the content of the tooltip matches what is rendered for the menu item.
    isScreenReaderAnnouncementDisabled canAppear={canTooltipAppear}>
				{tooltipProps => {
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
          ...tooltipProps,
          'aria-controls': ariaControls,
          'aria-haspopup': ariaHasPopup,
          ref: mergeRefs([forwardedRef, tooltipProps.ref]),
          id,
          testId,
          interactionName
        };
        return isLink ? <Anchor {...sharedProps} onClick={(handleClick as MenuItemOnClick<HTMLAnchorElement>)} xcss={cx(buttonOrAnchorStyles.root, isLarge && buttonOrAnchorStyles.large, isSmall && buttonOrAnchorStyles.small, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, noActiveBackground && buttonOrAnchorStyles.noActiveBackground)}
        // Needed to override Anchor style due to a compiled/emotion conflict
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style={{
          textDecoration: 'none'
        }} aria-current={isSelected ? 'page' : undefined} href={href} target={target}
        /**
         * rovo-navigation
         * Disable drag and drop for simpler implementation
         */ draggable={false}>
							{/* Won't be a "grid child" */}
							<div aria-hidden="true" className={ax([notchStyles.root])} />
							{interactiveElemContent}
						</Anchor> : <Pressable {...sharedProps} onClick={(handleClick as MenuItemOnClick<HTMLButtonElement>)} xcss={cx(buttonOrAnchorStyles.root, isLarge && buttonOrAnchorStyles.large, isSmall && buttonOrAnchorStyles.small, topLevelSiblingStyles.root, isSelected && buttonOrAnchorStyles.selected, noActiveBackground && buttonOrAnchorStyles.noActiveBackground)} aria-expanded={ariaExpanded} isDisabled={isDisabled}>
							{interactiveElemContent}
						</Pressable>;
      }}
			</Tooltip>
			{showElemBefore && <div className={ax([elemBeforeStyles.root, elemBeforeAlign === 'start' && elemBeforeStyles.start, isLarge && elemBeforeStyles.large, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{(elemBefore as React.ReactNode)}
				</div>}
			{actionsOnHover && <div className={ax([actionsOnHoverStyles.root])}>{actionsOnHover}</div>}
			{elemAfter && <div className={ax([elemAfterStyles.root, size === 'large' && elemAfterStyles.large, size === 'small' && elemAfterStyles.small, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{elemAfter}
				</div>}
			{actions && <div className={ax([actionStyles.root, topLevelSiblingStyles.root, onTopOfButtonOrAnchorStyles.root])}>
					{actions}
				</div>}
		</div>;
};

/**
 * __MenuItemBase__
 *
 * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */
export const MenuItemBase: <T extends HTMLAnchorElement | HTMLButtonElement>(props: MenuItemCommonProps & MenuItemSlots & {
  description?: React.ReactNode;
  listItemRef?: React.Ref<HTMLDivElement>;
} & {
  /**
   * ID attribute, passed to the interactive element (anchor/button). This is not publicly exposed, and is currently only
   * used internally by `ExpandableMenuItemTrigger` for the `aria-labelledby` attribute.
   */
  id?: string;
  href?: string | Record<string, unknown>;
  target?: HTMLAnchorElement['target'];
  isDisabled?: boolean;
  isSelected?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaControls?: string;
  // eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention, @repo/internal/react/consistent-props-definitions
  ariaExpanded?: boolean;
  // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
  ariaHasPopup?: boolean | 'dialog';
  onClick?: MenuItemOnClick<T> | undefined;
  /**
   * Size variant for the menu item.
   * - 'default': 2rem (32px) height
   * - 'small': 3.25rem (52px) minimum height with custom padding
   * - 'large': 3.75rem (60px) minimum height with custom padding
   */
  size?: 'default' | 'small' | 'large';
  /**
   * When true, disables the inner :active background on the anchor/button.
   * Useful when the container already provides its own pressed/selected highlight.
   */
  noActiveBackground?: boolean;
  /** Display actionsOnHover even when the menu item is not hovered or expanded. */
  showActionsOnHover?: boolean;
  elemBeforeAlign?: 'center' | 'start';
} & React.RefAttributes<T>) => React.ReactElement | null = forwardRefWithGeneric(MenuItemBaseNoRef);